import { useMemo, useState } from "react";
import { RateCard } from "./RateCard";
import type { RateRecord } from "./rates.model";
import { filterRates } from "./rates.model";

type RatesPublishProps = {
  rates: RateRecord[];
  onDelete: (id: string) => void;
};

export const RatesPublish = ({ rates, onDelete }: RatesPublishProps) => {
  const [query, setQuery] = useState("");
  const [published, setPublished] = useState(false);
  const shown = useMemo(() => filterRates(rates, { status: "ready", text: query }), [rates, query]);

  return (
    <div className="rt-pane">
      <div className="nw-list__hd">
        <div className="pcx__h">Commercial Review</div>
        <div className="nw-list__f">
          <label className="nw-search">
            <i />
            <input
              type="text"
              value={query}
              placeholder="Search by port or lane..."
              autoComplete="off"
              onChange={(event) => setQuery(event.target.value)}
            />
          </label>
          <button
            type="button"
            className="pcbtn pcbtn--main"
            disabled={shown.length === 0}
            onClick={() => setPublished(true)}
          >
            Publish rates
          </button>
        </div>
      </div>
      {published && (
        <p className="rt-hint">
          {shown.length} clean {shown.length === 1 ? "rate is" : "rates are"} marked published for this company. Selling
          rates use the +10% default until pricing rules land on the API.
        </p>
      )}
      <div className="rt-list">
        {shown.map((rate) => (
          <RateCard key={rate.id} rate={rate} variant="publish" onDelete={onDelete} />
        ))}
      </div>
      {shown.length === 0 && <p className="rt-empty">No rates match your search.</p>}
    </div>
  );
};
